import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import TextInput from "sub_components/Common/BloxTextInput";
import { INPUT_TYPES } from "utils/CommonConstants";
import { BloxButton } from "styled_components/Common/BloxButton";
import { Comment } from "./Comment";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const GrayPaperclipImage = `${CDN_URL}support/Support_Gray_PaperClip.svg`;
const PurplePaperclipImage = `${CDN_URL}support/Support_BrightPurple_PaperClip.svg`;
const HoverPaperclipImage = `${CDN_URL}support/Support_Hover_PaperClip.svg`;

const CommentsStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 495px;
  padding: 10px;

  flex: 1;
  white-space: pre-line;
  background: ${(props) => props.theme.componentBackground};
  //border: 1px solid blue;
  color: ${(props) => props.theme.defaultFontColor};
  .ticket-comments-wrapper {
    display: flex;
    width: 100%;
  }
  .buttons-wrapper {
    display: flex;
    justify-content: space-between;
    min-height: 35px;
    margin-top: 10px;
    padding: 5px;
    width: 100%;
    .image-wrapper {
      display: flex;
      width: 20px;
      height: 20px;
      .character-count-text {
        display: flex;
        flex-direction: center;
        justify-content: center;
        .message {
          width: 60px;
          margin-top: 6px;
          white-space: nowrap;
          text-align: left;
        }
      }
    }
    .buttons {
      display: flex;

      img {
        width: 15px;
        height: 15px;
        margin-top: 3px;
        margin-right: 5px;
        cursor: pointer;
      }
    }
    .attachment-icon {
      display: flex;
      position: relative;
      .attachment-details {
        position: absolute;
        width: 150px;
        min-height: 50px;
        margin-left: -60px;
        margin-top: -40px;
        background-color: #543c68;
        border-radius: 5px;
        padding: 5px;
        opacity: 0.85;
        border: 1px solid #543c68;
        z-index: 1000;

        .attachment-detail {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          color: white;
        }
      }
    }
  }
  .description-body {
    border: solid 4px ${(props) => props.theme.Cool_Gray_Light_1};
    .blox-text-input {
      width: 330px;
      height: 60px;
      padding: 5px 10px 10px;
      .text-area-description {
        min-height: 40px;
      }
      .active-field {
        min-height: 40px;
        max-height: 40px;
      }
      .checkmark,
      .label-row,
      .validation-row {
        display: none;
      }
    }
    .ScrollbarsCustom-Track {
      right: -10px !important;
      top: 0px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 6px !important;
    }
    .ScrollbarsCustom-TrackY:before {
      border-left: none;
    }
    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 6px !important;
    }
  }
  .comments-wrapper {
    height: 360px;
    width: 97%;
    .ScrollbarsCustom-Track {
      right: -10px !important;
      top: 0px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 6px !important;
    }
    .ScrollbarsCustom-TrackY:before {
      border-left: none;
    }
    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 6px !important;
    }
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    height: 574px;
    padding: 15px;

    .buttons-wrapper {
      min-height: 45px;
      margin-top: 15px;
      padding: 5px;
      .image-wrapper {
        width: 20px;
        height: 20px;
        .character-count-text {
          .message {
            width: 70px;
            margin-top: 6px;
          }
        }
      }
      .buttons {
        img {
          width: 20px;
          height: 20px;
          margin-top: 5px;
          margin-right: 10px;
          cursor: pointer;
        }
      }
    }
    .description-body {
      .blox-text-input {
        width: 515px;
        height: 80px;
        padding: 5px 10px 10px;
        .text-area-description {
          min-height: 50px;
        }
        .active-field {
          min-height: 50px;
          max-height: 50px;
        }
      }
      .ScrollbarsCustom-Track {
        right: -10px !important;
        top: 0px !important;
      }
      .ScrollbarsCustom-ThumbY {
        background-color: ${(props) => props.theme.support} !important;
        width: 6px !important;
      }
      .ScrollbarsCustom-TrackY:before {
        border-left: none;
      }
      .ScrollbarsCustom-TrackY {
        background-color: ${(props) =>
          props.theme.Cool_Gray_Light_2} !important;
        box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
          1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
        width: 6px !important;
      }
    }
    .comments-wrapper {
      height: 390px;
      width: 97%;
      margin-top: 10px;

      .ScrollbarsCustom-TrackY:before {
        border-left: none;
      }
      .ScrollbarsCustom-TrackY {
        background-color: ${(props) =>
          props.theme.Cool_Gray_Light_2} !important;
        box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
          1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
        width: 6px !important;
      }
      .ScrollbarsCustom-Track {
        right: -15px !important;
      }
      .ScrollbarsCustom-ThumbY {
        background-color: ${(props) => props.theme.support} !important;
        width: 8px !important;
      }
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    height: 975px !important;
    padding: 20px;

    .buttons-wrapper {
      min-height: 55px;
      margin-top: 20px;
      padding: 5px;
      .image-wrapper {
        width: 30px;
        height: 30px;
        .character-count-text {
          .message {
            width: 90px;
            margin-top: 6px;
          }
        }
      }
      .buttons {
        img {
          width: 30px;
          height: 30px;
          margin-top: 8px;
          margin-right: 15px;
        }
      }
    }
    .description-body {
      .blox-text-input {
        width: 865px;
        height: 130px;
        padding: 10px 15px 15px;
        .text-area-description {
          min-height: 80px;
        }
        .active-field {
          min-height: 80px;
          max-height: 80px;
        }
      }
      .ScrollbarsCustom-Track {
        right: -10px !important;
        top: 0px !important;
      }
      .ScrollbarsCustom-ThumbY {
        background-color: ${(props) => props.theme.support} !important;
        width: 6px !important;
      }
      .ScrollbarsCustom-TrackY:before {
        border-left: none;
      }
      .ScrollbarsCustom-TrackY {
        background-color: ${(props) =>
          props.theme.Cool_Gray_Light_2} !important;
        box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
          1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
        width: 6px !important;
      }
    }
    .comments-wrapper {
      height: 700px;
      width: 97%;
      margin-top: 15px;
      .ScrollbarsCustom-Track {
        right: -10px !important;
        top: 0px !important;
      }
      .ScrollbarsCustom-ThumbY {
        background-color: ${(props) => props.theme.support} !important;
        width: 6px !important;
      }
      .ScrollbarsCustom-TrackY:before {
        border-left: none;
      }
      .ScrollbarsCustom-TrackY {
        background-color: ${(props) =>
          props.theme.Cool_Gray_Light_2} !important;
        box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
          1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
        width: 6px !important;
      }
      .ScrollbarsCustom-Track {
        right: -10px !important;
      }
      .ScrollbarsCustom-ThumbY {
        background-color: ${(props) => props.theme.support} !important;
        width: 8px !important;
      }
    }

    .ScrollbarsCustom-Track {
      right: -10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) => props.theme.support} !important;
      width: 10px !important;
    }
  }
`;

function getCharactersLeft(value) {
  if (value?.length <= 227) {
    return 227 - value?.length;
  } else {
    return "";
  }
}

function getCharactertext(value) {
  if (value?.length <= 227) {
    return <div className="message">Characters Left</div>;
  } else {
    return (
      <div className="message error">
        Descriptions must be less than 227 characters
      </div>
    );
  }
}

function renderAttachmentDetails(newAttachments) {
  if (newAttachments?.length < 1) {
    return;
  }

  return (
    <div
      className={`attachment-details ${
        newAttachments?.length > 0 ? "show" : ""
      }`}
    >
      {newAttachments &&
        newAttachments.map((attachment) => {
          return (
            <div
              key={`${attachment.filename}-${attachment.index}`}
              className="attachment-detail"
            >
              <div className="filename">{attachment.filename}</div>
              <div className="filesize">{attachment.size}</div>
            </div>
          );
        })}
    </div>
  );
}

function enableSubmitButton(value, newAttachments) {
  return (
    (value?.length >= 10 && value?.length <= 227) || newAttachments?.length > 0
  );
}

export const Comments = ({
  ticketDetails,
  breakpoint,
  newAttachments,
  onSubmit,
  attachFile,
  description,
  setDescription,
  jiraComments,
}) => {
  const [showFiles, setShowFiles] = useState(false);
  const [comments, setComments] = useState([]);

  useEffect(() => {
    setComments(jiraComments);
  }, [ticketDetails, jiraComments]);

  const attachments = [];
  return (
    <CommentsStyle className="ticket-comments-wrapper">
      <div className="description-body">
        <TextInput
          placeholder="Add a new comment..."
          type={INPUT_TYPES.TEXTAREA}
          label=""
          name="description"
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          active={true}
          setDefaultValueAsPlaceholder
          breakpoint={breakpoint}
          cypressId="ticket-comment-text-area"
        />
      </div>
      <div className="buttons-wrapper">
        <div className="image-wrapper">
          <div className="character-count-text">
            {getCharactertext(description)}
            <div className="character-count">
              {getCharactersLeft(description)}
            </div>
          </div>
        </div>
        <div className="buttons">
          <div
            onClick={attachFile}
            onMouseEnter={() => setShowFiles(true)}
            onMouseLeave={() => setShowFiles(false)}
            className="attachment-icon"
            data-cy="attachment-icon"
          >
            {newAttachments?.length > 0 && (
              <div className="attachment-count footer20">
                {`${newAttachments?.length} ${
                  newAttachments?.length > 1 ? "DOCS" : "DOC"
                }`}
              </div>
            )}
            <img
              onMouseEnter={(e) => (e.currentTarget.src = HoverPaperclipImage)}
              onMouseLeave={(e) =>
                (e.currentTarget.src =
                  attachments.length > 0
                    ? PurplePaperclipImage
                    : GrayPaperclipImage)
              }
              src={
                attachments.length > 0
                  ? PurplePaperclipImage
                  : GrayPaperclipImage
              }
              className="paperclip-img"
              alt="attach"
            />
            {showFiles && renderAttachmentDetails(newAttachments)}
          </div>
          <BloxButton
            className="buttons41"
            id="comment-submit-button"
            text="ADD COMMENT"
            module="support"
            enabled={enableSubmitButton(description, newAttachments)}
            onClick={onSubmit}
            cypressId={"comment-submit-button"}
          />
        </div>
      </div>

      <div className="comments-wrapper">
        <ScrollView>
          {comments &&
            comments.map((comment, index) => (
              <Comment index={index} comment={comment} />
            ))}
          {!comments ||
            (comments && comments?.length === 0 && (
              <div className="footer20">No comments to view.</div>
            ))}
        </ScrollView>
      </div>
    </CommentsStyle>
  );
};
// LargeInfoDisplay.propTypes = {
// 	type: string.isRequired,
// };

// LargeInfoDisplay.defaultProps = {};
